import * as React from "react";
import { tokens } from "@fluentui/react-components";

interface SettingsSectionProps {
  title: string;
  children: React.ReactNode;
}

const SettingsSection: React.FC<SettingsSectionProps> = ({ title, children }) => {
  return (
    <div style={{ marginBottom: "32px" }}>
      <h2 style={{
        fontSize: tokens.fontSizeBase500,
        fontWeight: tokens.fontWeightSemibold,
        marginBottom: "20px",
        color: tokens.colorNeutralForeground1,
      }}>
        {title}
      </h2>
      {children}
    </div>
  );
};

export default SettingsSection;